import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';

import { withStyles } from '@material-ui/core/styles';

import { editCrewForm } from '../../../store/actions';

const styles = theme => ({
  card: {
    marginTop: theme.spacing.unit*3,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  marginRight: {
    marginRight: theme.spacing.unit*2,
  },
  marginLeft: {
    marginLeft: theme.spacing.unit*2,
  },
});

const CrewForm = ({ classes, crew, editCrewForm }) => {
  const { validation } = crew;

  return (
    <Card className={classes.card}>
      <CardContent className={classes.content}>
        <div>
          <TextField
            error={!!validation.validateField("crewFirstName")}
            helperText={validation.validateField("crewFirstName")}
            className={classes.marginRight}
            label="Name"
            margin="none"
            value={crew && crew.crewFirstName}
            onChange={(event) => editCrewForm({crewFirstName: event.target.value})}
          />
          <TextField
            error={!!validation.validateField("email")}
            helperText={validation.validateField("email")}
            className={classes.marginRight}
            label="Email"
            margin="none"
            value={crew && crew.email}
            onChange={(event) => editCrewForm({email: event.target.value})}
          />
        </div>
      </CardContent>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  crew: state.formData.crew,
});

const mapDispatchToProps = {
  editCrewForm,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(CrewForm);



// WEBPACK FOOTER //
// ./src/components/admin/Crew/CrewForm.jsx